// extracted by mini-css-extract-plugin
export var genericHolder = "generic-module--genericHolder--dTq7U";